import { render, staticRenderFns } from "./ProjectHome.vue?vue&type=template&id=08ffc934&scoped=true&"
import script from "./ProjectHome.vue?vue&type=script&lang=js&"
export * from "./ProjectHome.vue?vue&type=script&lang=js&"
import style0 from "./ProjectHome.vue?vue&type=style&index=0&id=08ffc934&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ffc934",
  null
  
)

export default component.exports